<template>
  <div id="gdxx">
    <div v-for="item in list">
      <p><b>股东名称：</b> {{item.GDMC}} </p>
      <p><b>持股比例	：</b> {{item.CGBL}} </p>
      <p><b>入股时间：</b> {{item.RGSJ}} </p>
      <p><b>法定代表人：</b> {{item.FR}} </p>
      <p><b>办公地址	：</b> {{item.BGDZ}} </p>
      <p><b>公司网址：</b> {{item.GSWZ}} </p>
      <p><b>所属行业：</b> {{item.SSHY}} </p>
      <p><b>经济类型：</b> {{item.JJLX}} </p>
      <p><b>备注：</b> {{item.BZ}} </p>
      <div v-if="list.length > 1" class="line"></div>
      <div class="margin-b"></div>
    </div>
  </div>
</template>

<script>
  import ajax from '@/common/ajax/ajax'

  export default {
    name: 'gdxx',
    data () {
      return {
        list: [{xm: '数据读取中'}]
      }
    },
    mounted () {
      this.getData()
    },
    methods: {
      getData () {
        ajax.getGDXX().then(
          data => {
            this.list = data
          }
        )
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  .line{
    border-bottom : dotted 1px #000000;
    height : 1px;
  }

</style>



// WEBPACK FOOTER //
// gdxx.vue?9fa43842